
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photo-colorizer",
      function () {
        return require("private-next-pages/photo-colorizer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photo-colorizer"])
      });
    }
  